import './has-role.component.ajscss';

import { IComponentOptions } from 'angular';

import { PermissionCtrl } from '../models/abstract-permission-ctrl';
import templateUrl from './has-role.component.html';

class HasRoleCtrl extends PermissionCtrl {}

export class HasRole implements IComponentOptions {
  templateUrl = templateUrl;
  transclude = true;
  bindings = {
    name: '=',
  };
  controller = ['sessionDeprecatedService', HasRoleCtrl];
}

export default 'hasRole';
